<script lang="ts" setup>
// Import styles.
import 'vidstack/player/styles/base.css';
// Register elements.
import 'vidstack/player';
import 'vidstack/player/ui';
import 'vidstack/icons';


import { isHLSProvider, type MediaCanPlayEvent, type MediaProviderChangeEvent } from 'vidstack';
import type { MediaPlayerElement } from 'vidstack/elements';
import { computed, onMounted, onBeforeUnmount, ref } from 'vue';
import { PlayerStore } from '@/front/stores/player_store.js';
const playerStore = PlayerStore();

import VideoLayout from '@/front/components/player/components/layouts/VideoLayout.vue';

const props = defineProps({
  controls: {
    type: Boolean,
    default: true,
  },
  loop: {
    type: Boolean,
    default: false,
  },
})


const domVideo = ref<HTMLVideoElement>();
import { VideoStore } from '@/front/stores/video_store.js';
const videoStore = VideoStore();
import { UploadStore } from '@/front/stores/upload_store.js';
const uploadStore = UploadStore();

const $loopPlayer = ref<MediaPlayerElement>();
const $src = ref('');


// Method to extract the video source from the video object
function getVideoSource(video) {
  return uploadStore.uploadFile && uploadStore.uploadSource
    ? uploadStore.uploadSource
    : video.source?.hls || video.source?.mp4 || video.source?.s3 || '';
}

const emit = defineEmits(['ended'])

onMounted(() => {
  // const { currentSrc, controlsHidden, currentTime, duration, fullscreen, playing, qualities, quality, seekableEnd, seekableStart, textTrack, volume, waiting, controlsVisible, ended, error, height, muted, paused, playbackRate, seeking, started, width } = $player.value?.state
  $src.value = getVideoSource(videoStore.video)
  log.info(3, "🌜 LoopingPlayer $src", $src.value)

  // $player.value?.subscribe(({ currentSrc, controlsHidden, fullscreen, playing, qualities, quality, seekableEnd, seekableStart, textTrack, volume, waiting, controlsVisible, duration, ended, error, height, muted, paused, playbackRate, seeking, started, width }) => {
  //   clipStore.setPlayerState({ currentSrc, controlsHidden, fullscreen, playing, qualities, quality, seekableEnd, seekableStart, textTrack, volume, waiting, controlsVisible, duration, ended, error, height, muted, paused, playbackRate, seeking, started, width })
  // });
});

function onProviderChange(event: MediaProviderChangeEvent) {
  const provider = event.detail;
  // We can configure provider's here.
  if (isHLSProvider(provider)) {
    provider.config = {};
  }
}

// function onEnded() {
//   log.info(5,"ClipPlayer onEnded emitting ended")
//   emit('ended')
// }

  //

// We can listen for the `can-play` event to be notified when the player is ready.
function onCanPlay(event: MediaCanPlayEvent) {
  setTimeout(() => {
    domVideo.value = document.querySelector('#loop-player video')
    // log.info(5,"LoopingPlayer onCanPlay", domVideo.value)
    domVideo.value.muted = true
    domVideo.value.volume = 0
    domVideo.value.play()
  }, 10)
  // ...
}

// onBeforeUnmount(() => {
//   clipStore.clear()
// })

function onTimeUpdate(event: MediaTimeUpdateEvent) {
  const t = Math.floor(event.detail.currentTime)
  if (t > 5) {
    domVideo.value.currentTime = 0
  }
}

const getCrossOrigin = computed(() => {
  // log.info(5,"🌜 Player getCrossOrigin", $src.value)
  if ($src.value.includes("cloudfront")) {
    return false
  } else if ($src.value.includes("panopto")) {
    return 'anonymous'
  } else {
    return 'anonymous'
  }
});

// const onLoopClick = () => {
//   log.info(5,"LoopingPlayer onClipClick")
//   playerStore.togglePlayer()
//   return
//   // emit('click')
// }

const onError = (event) => {
  log.info(5,"🌜 LoopingPlayer onError", event);
  if (videoStore.video.source.backup_hls && $loopPlayer.value.src != videoStore.video.source.backup_hls) {
    setTimeout(() => {
      log.info(5,"🌜 LoopingPlayer onError, switching to backup HLS", videoStore.video.source.backup_hls);
      if ($loopPlayer.value) {
        $loopPlayer.value.src = videoStore.video.source.backup_hls;
      }
    }, 50)
  } else {
    playerStore.error = event.detail.message;
  }
};

const loadStrategy = computed(() => {
  if (playerStore.isMobile && !playerStore.isWebView) {
    return "idle";
  }
  return "eager";
});

</script>

<template>
  <media-player
    :load="loadStrategy"
    class="w-full aspect-video bg-black text-white font-sans overflow-hidden ring-media-focus data-[focus]:ring-4"
    :class="{ 'cover-mode': videoStore.video?.design?.cover_mode }"
    :src="$src"
    :crossOrigin="getCrossOrigin"
    playsInline
    loop
    :muted="true"
    @ended="onEnded"
    @provider-change="onProviderChange"
    @time-update="onTimeUpdate"
    @error="onError"
    @can-play="onCanPlay"
    ref="$loopPlayer"
    id="loop-player"
  >
    <media-provider id="loop-media-provider">
    </media-provider>
  </media-player>
</template>

<style>
#loop-media-provider video {
  height: 100%;
}
#loop-player.cover-mode video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>